<p-toast [position]="position" (onClose)="onCloseMessage($event)">
  <ng-template let-message pTemplate="message">
    <h3>{{message.summary}}</h3>
    <div class="detail">
      <p>{{message.detail}}</p>
      @if (message.data?.list) {
        <ul class="toast-message-list">
          @for (item of message.data.list; track item) {
            <li>{{item}}</li>
          }
        </ul>
      }
      @if (message.data?.text) {
        <p class="toast-message-text">
          {{message.data.text}}
        </p>
      }
      @if (message.data?.button) {
        <p>
          <button pButton (click)="message.data.button.action()">{{message.data.button.label}}</button>
        </p>
      }
      @if (message.data?.[countSymbol] && message.data?.[countSymbol] > 1) {
        <data
          aria-label="Number of times this message has occurred" class="duplicate-message-occurrences"
          [value]="message.data[countSymbol]">
          {{ message.data[countSymbol] | number }} more messages like this
        </data>
      }
    </div>
  </ng-template>
</p-toast>

@if (authMessage) {
  <div class="p-toast p-component p-toast-center-center"
    style="top: 50%; left: 50%; margin: -10rem 0 0 -6rem; z-index: 2000">
    <div class="p-toast-message p-toast-message-info">
      <div class="p-toast-message-content">
        <h3>{{authMessage.summary}}</h3>
        <p>{{authMessage.detail}}</p>
        <div style="text-align: center;">
          <i class="pi pi-spinner pi-spin"></i>
        </div>
      </div>
    </div>
  </div>
}
